import {applyMiddleware, combineReducers, createStore} from 'redux';
import {reducer as formReducer} from 'redux-form'
import createHistory from 'history/createBrowserHistory';
import {routerMiddleware, routerReducer} from "react-router-redux";
import axios from 'axios';
import axiosMiddleware from 'redux-axios-middleware';

import {usersReducer} from "./redux/reducers/users";
import {regulationsReducer} from "./redux/reducers/regulations";
import {companiesReducer} from "./redux/reducers/companies";
import {tasksReducer} from "./redux/reducers/tasks";
import {appReducer} from "./redux/reducers/app";
import {postsReducer} from "./redux/reducers/posts";
import {regulationCategoriesReducer} from "./redux/reducers/regulation_categories";
import {regulationResultsReducer} from "./redux/reducers/regulation_results";
import {reportsReducer} from "./redux/reducers/reports";
import {snackMessageReducer} from "./redux/reducers/snack_message";
import {drawerReducer} from "./redux/reducers/drawer";
import {filterReducer} from "./redux/reducers/filter";

export const history = createHistory();

const client = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    responseType: 'json',
    headers: {
        'access-token': localStorage.getItem('access-token'),
        'client': localStorage.getItem('client'),
        'uid': localStorage.getItem('uid'),
    }
});

client.interceptors.request.use((config) => {
    if (localStorage.getItem('access-token') != null) {
        config.headers['access-token'] = localStorage.getItem('access-token');
        config.headers['client'] = localStorage.getItem('client');
        config.headers['uid'] = localStorage.getItem('uid');
        }
        return config;
    }
);

client.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response.status === 401 && window.location.pathname !== '/') {
            history.push('/');
        }
        return Promise.reject(error);
    }
);

let _formReducer = formReducer.plugin({
    post: (state, action) => {
        switch (action.type) {
            case 'API_CREATE_POST_SUCCESS':
                return undefined;
            default:
                return state;
        }
    }
});

export const store = createStore(
    combineReducers({
        router: routerReducer,
        users: usersReducer,
        regulations: regulationsReducer,
        regulation_categories: regulationCategoriesReducer,
        regulation_results: regulationResultsReducer,
        companies: companiesReducer,
        tasks: tasksReducer,
        posts: postsReducer,
        reports: reportsReducer,
        snack_message: snackMessageReducer,
        drawer: drawerReducer,
        filter: filterReducer,
        app: appReducer,
        form: _formReducer,
    }),
    applyMiddleware(
        routerMiddleware(history),
        axiosMiddleware(client),
    )
);





// WEBPACK FOOTER //
// ./src/store.js